type ScreenDetails = { currentScreen: Screen; screens: Array<Screen & { availLeft: number; availTop: number }> };
type WindowWithScreens = Window & { getScreenDetails?: () => Promise<ScreenDetails> };

/** Call directly from the cashier's click so popup blockers can honor the gesture. */
export async function openDisplayWindow(url: string): Promise<'opened' | 'blocked'> {
  const popup = window.open(url, 'washday-customer-display', 'popup,width=1100,height=800');
  if (!popup) return 'blocked';
  popup.opener = null;
  const getScreenDetails = (window as WindowWithScreens).getScreenDetails;
  if (getScreenDetails) {
    try {
      const details = await getScreenDetails.call(window);
      const screen = details.screens.find((candidate) => candidate !== details.currentScreen);
      if (screen) {
        popup.moveTo(screen.availLeft, screen.availTop);
        popup.resizeTo(screen.availWidth, screen.availHeight);
      }
    } catch { /* Permission denied: the opened window can still be moved manually. */ }
  }
  return 'opened';
}
